import axios from "axios";
import authService from "_services/auth.service";

export const cardsApi = axios.create({
  baseURL: process.env.REACT_APP_CARDS_API,
});

export const pedidosApi = axios.create({
  baseURL: process.env.REACT_APP_PEDIDOS_API,
  timeout: 60000
});

export const couponApi = axios.create({
  baseURL: process.env.REACT_APP_CUPONS_API,
});

export const produtosApi = axios.create({
  baseURL: process.env.REACT_APP_PRODUTOS_API,
});

export const CATEGORY_TREE_ENDPOINT = `/v1/categoria/${process.env.REACT_APP_DEFAULT_CHANNEL}/tree`;

export const clientesApi = axios.create({
  baseURL: process.env.REACT_APP_CLIENTES_API,
});

export const configApi = axios.create({
  baseURL: process.env.REACT_APP_CONFIGS_API,
});

export const configApiBasic = axios.create({
  baseURL: process.env.REACT_APP_CONFIGS_API,
  headers: {
    Authorization: `Bearer ${process.env.REACT_APP_CONFIGS_API_TOKEN}`,
  },
});


const ensureAuthToken = async () => {
  try {
    return await authService.ensureValidToken();
  } catch (error) {
    console.error("Erro ao obter token de autorização:", error);
    throw error;
  }
};

cardsApi.interceptors.request.use(async (config) => {
  try {
    const authToken = await ensureAuthToken();
    config.headers.Authorization = `Bearer ${authToken}`;
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});

produtosApi.interceptors.request.use(async (config) => {
  try {
    const authToken = await ensureAuthToken();
    config.headers.Authorization = `Bearer ${authToken}`;
    config.headers['X-Client-ID'] = process.env.REACT_APP_DEFAULT_CHANNEL;
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});

pedidosApi.interceptors.request.use(async (config) => {
  try {
    const authToken = await ensureAuthToken();
    config.headers.Authorization = `Bearer ${authToken}`;
    config.headers['X-Client-ID'] = process.env.REACT_APP_DEFAULT_CHANNEL;
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});

clientesApi.interceptors.request.use(async (config) => {
  try {
    const authToken = await ensureAuthToken();
    config.headers.Authorization = `Bearer ${authToken}`;
    config.headers['X-Client-ID'] = process.env.REACT_APP_DEFAULT_CHANNEL;
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});

configApi.interceptors.request.use(async (config) => {
  try {
    const authToken = await ensureAuthToken();
    config.headers.Authorization = `Bearer ${authToken}`;
    config.headers['X-Client-ID'] = process.env.REACT_APP_DEFAULT_CHANNEL;
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});

couponApi.interceptors.request.use(async (config) => {
  try {
    const authToken = await ensureAuthToken();
    config.headers.Authorization = `Bearer ${authToken}`;
    config.headers['X-Client-ID'] = process.env.REACT_APP_DEFAULT_CHANNEL;
    return config;
  } catch (error) {
    return Promise.reject(error);
  }
});